import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent } from "@/components/ui/card";
import { API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { extractErrorMessage } from "@/lib/errorMessage";
import { FileText } from "lucide-react";
import { ConferenciaForm } from "@/components/logistica/ConferenciaForm";

// Conferencia lancada a partir da 2a via em PAPEL (sem sinal na obra) — usuario logado da Logistica
export default function ConferenciaPapelPage() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/logistica/romaneios/${id}`),
      axios.get(`${API}/funcionarios`),
    ]).then(([res, f]) => setR({
      ...res.data,
      read_only: !["em_transito", "nao_confirmado"].includes(res.data.status),
      vinculos: f.data.map(x => ({ id: x.id, nome: x.nome })),
    })).catch(() => toast.error("Romaneio não encontrado"));
  }, [id]);

  const enviar = async (payload) => {
    setEnviando(true);
    try {
      const res = await axios.post(`${API}/logistica/romaneios/${r.id}/conferir-papel`, payload);
      toast.success(res.data.message);
      window.location.href = `/logistica/romaneios/${r.id}`;
    } catch (err) { toast.error(extractErrorMessage(err, "Erro ao lançar conferência")); }
    finally { setEnviando(false); }
  };

  if (!r) return <MainLayout><div className="py-16 text-center text-slate-400">Carregando…</div></MainLayout>;

  return (
    <MainLayout>
      <div className="max-w-xl space-y-3" data-testid="conferencia-papel-page">
        <div>
          <h1 className="text-2xl font-bold text-luvcorp-navy flex items-center gap-2">
            <FileText className="h-6 w-6 text-luvcorp-gold" /> Lançar conferência do papel — {r.numero}
          </h1>
          <p className="text-sm text-slate-500">{r.obra_titulo} · Digite o que está na 2ª via assinada e <b>anexe a foto dela (obrigatória)</b>. Ficará registrado "lançada a partir do papel" com seu usuário.</p>
        </div>
        {r.read_only ? (
          <Card className="border-0 shadow-sm"><CardContent className="p-8 text-center text-slate-500">Este romaneio já foi conferido.</CardContent></Card>
        ) : (
          <ConferenciaForm romaneio={r} modo="papel" onSubmit={enviar} enviando={enviando} />
        )}
      </div>
    </MainLayout>
  );
}
